module.exports = __webpack_public_path__ + "img/phone.0edb3478.png";